import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Avatar } from 'primereact/avatar';
import { useAuth } from 'providers/AuthenticationProvider';
import httpMethod from './services/update2025/httpMethod';

export const AppTopbar = (props) => {
    const auth = useAuth();
    const isLogged = auth.isLogged;
    const user = httpMethod.getUserStorage();
    const logout = () => {
        return auth.logout();
    };

    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">
                <img
                    src={`${process.env.PUBLIC_URL}/assets/layout/images/logo.png`}
                    alt="logo"
                />
                <span>VNeID ADMIN</span>
            </Link>

            <button
                type="button"
                className="p-link  layout-menu-button layout-topbar-button"
                onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>

            <button
                type="button"
                className="p-link layout-topbar-menu-button layout-topbar-button"
                onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul
                className={classNames('layout-topbar-menu lg:flex origin-top', {
                    'layout-topbar-menu-mobile-active':
                        props.mobileTopbarMenuActive
                })}>
                {isLogged && (
                    <>
                        <Avatar
                            image={`${process.env.PUBLIC_URL}/assets/layout/images/avatar.png`}
                            shape="circle"
                            size="large"
                        />
                        <li>
                            <div className="layout-topbar-avatar">
                                <span>{user?.HoVaTen}</span>
                            </div>
                        </li>

                        <li>
                            <button
                                className="p-link layout-topbar-button"
                                onClick={logout}>
                                <i className="pi pi-sign-out" />
                            </button>
                        </li>
                    </>
                )}
            </ul>
        </div>
    );
};
